import React from 'react';
import './NoSpinAlert.css';
import CloseIcon from '@mui/icons-material/Close';

const NoSpinAlert = ({ onClose, onClaim, claimLoading = false, colors = {} }) => {
  return (
    <div className="no-spin-overlay" onClick={onClose}>
      <div
        className="no-spin-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="no-spin-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-button" onClick={onClose} aria-label="Kapat">
          <CloseIcon fontSize="small" />
        </button>

        <div className="no-spin-content">
          <div className="alert-x" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <line x1="5" y1="5" x2="19" y2="19" />
              <line x1="19" y1="5" x2="5" y2="19" />
            </svg>
          </div>

          <h2 id="no-spin-title" style={{ color: colors.noSpinModalTitle || '#FFFFFF' }}>
            Spin Hakkı Bulunamadı
          </h2>
          <p style={{ color: colors.noSpinModalText || 'rgba(255, 255, 255, 0.62)' }}>
            Üzgünüz, şu anda aktif bir spin hakkınız bulunmuyor.
          </p>

          <div className="no-spin-actions">
            <button
              type="button"
              className="nsa-btn nsa-btn-primary"
              onClick={onClaim}
              disabled={claimLoading || !onClaim}
            >
              {claimLoading ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.4"
                  strokeLinecap="round"
                  className="nsa-btn-spin"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" strokeDasharray="40 60" />
                </svg>
              ) : null}
              <span>Talep Et</span>
            </button>

            <button
              type="button"
              className="nsa-btn nsa-btn-secondary"
              onClick={onClose}
            >
              Tamam
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoSpinAlert;
